import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import { AppLayout, Alert, BreadcrumbGroup, TopNavigation } from "@cloudscape-design/components"
import Home from "./routes/Home";
import Search from "./routes/Search";
import Dashboard from "./routes/Dashboard/index";
import Login from "./routes/Login";
import AdminIndex from "./routes/AdminIndex";
import AdminReportsIndex from "./routes/AdminReportsIndex";
import AdminReportsScores from "./routes/AdminReportsScores";
import PhoneDirectoryAdmin from "./routes/PhoneDirectoryAdmin";
import { useEffect, useState } from "react";
import { payloadFromToken, logOut } from "./api/auth";

const routes = [
  {
    path: "/search",
    name: "Search",
    Component: Search,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "../" },
          { text: "Search", href: "search" }
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
  {
    path: "/dashboard/parsedFiles/search",
    name: "Search",
    Component: Search,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "../" },
          { text: "Search", href: "search" }
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
  {
    path: "/dashboard/:key*",
    name: "Call Details",
    hide: true,
    Component: Dashboard,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "../../" },
          { text: "Call List", href: "../../" },
          { text: "Call Details", href: "#" },
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
  {
    path: "/admin/reports/scores",
    name: "Average Scores",
    Component: AdminReportsScores,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "/" },
          { text: "Admin", href: "/admin" },
          { text: "Reports", href: "/admin/reports" },
          { text: "Average Scores", href: "#" }
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
  {
    path: "/admin/reports",
    name: "Reports",
    Component: AdminReportsIndex,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "/" },
          { text: "Admin", href: "/admin" },
          { text: "Reports", href: "#" }
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
  {
    path: "/admin/phone-directory",
    name: "Phone Directory",
    Component: PhoneDirectoryAdmin,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "../" },
          { text: "Phone Directory", href: "#" }
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
  {
    path: "/admin",
    name: "Admin",
    Component: AdminIndex,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "../" },
          { text: "Admin", href: "#" }
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
  {
    path: "/",
    name: "Call List",
    Component: Home,
    Breadcrumb: () => {
      return <BreadcrumbGroup
        items={[
          { text: "Home", href: "#" },
          { text: "Call List", href: "#" },
        ]}
        ariaLabel="Breadcrumbs"
      />
    }
  },
];

function Navigation({ userName, email }) {
  return (
    <TopNavigation
      identity={{
        href: "/",
        title: "Insurance Navy AI Call Dashboard",
        iconName: "settings"
      }}
      i18nStrings={{
        searchIconAriaLabel: "Search",
        searchDismissIconAriaLabel: "Close search",
        overflowMenuTriggerText: "More",
        overflowMenuTitleText: "All",
        overflowMenuBackIconAriaLabel: "Back",
        overflowMenuDismissIconAriaLabel: "Close menu"
      }}
      utilities={[
        {
          type: "button",
          text: "Search",
          iconName: "search",
          href: "search",
          externalIconAriaLabel: " (opens in a new tab)"
        },
        {
          type: "button",
          text: "",
          href: "https://www.insurancenavy.com/",
          external: true,
          externalIconAriaLabel: " (opens in a new tab)"
        },
        {
          type: "menu-dropdown",
          text: userName,
          description: email,
          iconName: "user-profile",
          onItemClick: (event) => {
            console.log(event);
            if (event.detail.id === "signout") logOut();
          },
          items: [
            /* { id: "profile", text: "Profile" },
            { id: "preferences", text: "Preferences" },
            { id: "security", text: "Security" },*/
            {
              id: "support-group",
              text: "Support",
              items: [
                {
                  id: "documentation",
                  text: "Link 1",
                  href: "https://www.insurancenavy.com/",
                  external: true,
                  externalIconAriaLabel:
                    " (opens in new tab)"
                },
                {
                  id: "feedback",
                  text: "Link 2",
                  href: "https://www.insurancenavy.com/",
                  external: true,
                  externalIconAriaLabel:
                    " (opens in new tab)"
                }
              ]
            },
            { id: "signout", text: "Sign out" }
          ]
        }

      ]}
    />
  );
}

function App() {
  const [alert, setAlert] = useState();
  const [userToken, setUserToken] = useState(() =>
    localStorage.getItem("id_token")
  );

  const onDismiss = () => {
    setAlert(null);
  };

  useEffect(() => {
    const handleStorage = (event) => {
      if (!event || event.key === "id_token") {
        setUserToken(localStorage.getItem("id_token"));
      }
    };

    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const refreshUserToken = () => {
    setUserToken(localStorage.getItem("id_token"));
  };

  let parsedToken = {};
  if (userToken) {
    try {
      parsedToken = payloadFromToken(userToken);
    } catch (err) {
      console.debug("Invalid token in storage, continuing without auth", err);
    }
  }
  const cognitoUserName = parsedToken["cognito:username"] || "Guest";
  const cognitoEmail = parsedToken["email"] || "";

  return (
    <Router>
      <Switch>
        <Route path="/login">
          <Login onAuthChanged={refreshUserToken} />
        </Route>
        {routes.map(({ path, Component, Breadcrumb, name }) => (
          <Route key={path} path={path}>
            <Navigation userName={cognitoUserName} email={cognitoEmail} />
            <AppLayout
              className={path === "/" ? "call-list-app-layout" : undefined}
              maxContentWidth={path === "/" ? Number.MAX_VALUE : undefined}
              stickyNotifications
              toolsHide
              navigationHide
              breadcrumbs={
                <Breadcrumb/>
              }
              notifications={alert && (
                <Alert
                  variant={alert.variant}
                  dismissible
                  header={alert.heading}
                  onDismiss={onDismiss}
                >
                  {alert.text}
                </Alert>
              )}
              content={
                <Component setAlert={setAlert} />
              }
            />
          </Route>
        ))}
      </Switch>
    </Router>
  );
}

export default App;
